export default __webpack_public_path__ + "images/quote-gotham.png?bf3d589d7baf5d8a0bb477004e9a9b52";